
import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import MaintenancePage from './pages/MaintenancePage';
import CourseEvaluationPage from './pages/CourseEvaluationPage';
import LecturerEvaluationPage from './pages/LecturerEvaluationPage';
import EvaluationDetailsPage from './pages/EvaluationDetailsPage';
import CommunityPage from './pages/CommunityPage';
import ElectronicServicesPage from './pages/ElectronicServicesPage';
import CalculatorPage from './pages/CalculatorPage';
import AboutPage from './pages/AboutPage';
import TermsPage from './pages/TermsPage';
import ProfilePage from './pages/ProfilePage';

import DashboardPage from './pages/Admin/DashboardPage';
import UserManagementPage from './pages/Admin/UserManagementPage';
import ActivityLogPage from './pages/Admin/ActivityLogPage';
import ReportsPage from './pages/Admin/ReportsPage';
import AddCourseLecturerPage from './pages/Admin/AddCourseLecturerPage';
import ManageCourseLecturerPage from './pages/Admin/ManageCourseLecturerPage';

import RequireAdmin from './RequireAdmin';
import ComingSoonPage from './pages/ComingSoonPage';
import NotFoundPage from './pages/NotFoundPage';
import LoadingScreen from './components/LoadingScreen';

import MaintenanceGate from './routes/MaintenanceGate';

import MaintenanceControlPage from './pages/Owner/MaintenanceControlPage';
import PopupSettingsPage from './pages/Admin/PopupSettingsPage';


import ResetPasswordPage from './pages/ResetPasswordPage';
import FileStoragePage from './pages/FileStoragePage';
import RamadanSchedulePage from "./pages/RamadanSchedulePage";
import AcademicPlannerPage from './pages/AcademicPlannerPage';
import StudentExplanationsPage from './pages/StudentExplanationsPage';



const ADMIN_PATHS = [
  '/dashboard',
  '/user-management',
  '/activity-log',
  '/reports',
  '/add-course-lecturer',
  '/manage-courses-lecturers',
  '/maintenance-control',
  '/popup-settings',
  //'/course-evaluation'
];//lastupdate 

function getOrCreateSessionId() {
  if (typeof window === 'undefined') return null;
  try {
    const existing = window.localStorage.getItem('siteSessionId');
    if (existing) return existing;

    const id =
      Date.now().toString(36) +
      '-' +
      Math.random().toString(36).slice(2, 10);

    window.localStorage.setItem('siteSessionId', id);
    return id;
  } catch {
    return null;
  }
}

function AppContent() {
  const location = useLocation();

  const isAdminRoute = ADMIN_PATHS.some((path) =>
    location.pathname.startsWith(path)
  );

  const [sessionId] = useState(() => getOrCreateSessionId());


  const [onlineNow, setOnlineNow] = useState(() => {
    if (typeof window === 'undefined') return 0;
    try {
      const raw = window.localStorage.getItem('onlineNow') || '0';
      const value = parseInt(raw, 10);
      return Number.isFinite(value) && value >= 0 ? value : 0;
    } catch {
      return 0;
    }
  });


useEffect(() => {
  const controller = new AbortController();

  const track = async () => {
    try {
      const token =
        typeof window !== 'undefined'
          ? window.localStorage.getItem('authToken') || ''
          : '';

      await fetch('/api/track', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          eventType: 'page_view',
          pagePath: location.pathname + location.search,
          pageTitle: typeof document !== 'undefined' ? document.title : null,
          referrer: typeof document !== 'undefined' ? document.referrer || null : null,
          sessionId: sessionId,
        }),
        signal: controller.signal,
      });
    } catch {

    }
  };

  track();

  return () => controller.abort();
}, [location.pathname, location.search, sessionId]);





  useEffect(() => {
    const readFromStorage = () => {
      try {
        const raw = localStorage.getItem('onlineNow') || '0';
        const value = parseInt(raw, 10);
        if (Number.isFinite(value) && value >= 0) {
          setOnlineNow(value);
        }
      } catch {

      }
    };

    readFromStorage();

    const handleStorage = (event) => {
      if (event.key === 'onlineNow') {
        readFromStorage();
      }
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);


  useEffect(() => {
    let cancelled = false;

    const fetchOnlineNow = async () => {
      try {
        const token =
          typeof window !== 'undefined'
            ? window.localStorage.getItem('authToken') || ''
            : '';

        const resp = await fetch(
          '/api/dashboard/evaluations?timeRange=week',
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: token ? `Bearer ${token}` : ''
            }
          }
        );

        if (!resp.ok) {
          return;
        }

        const api = await resp.json();

        const n =
          (api.presence && api.presence.onlineNow) ||
          (api.cards && api.cards.onlineNow) ||
          0;

        const safe = Number.isFinite(n) && n >= 0 ? n : 0;

        if (!cancelled) {
          setOnlineNow(safe);
        }

        try {
          if (typeof window !== 'undefined') {
            window.localStorage.setItem('onlineNow', String(safe));
          }
        } catch {

        }
      } catch {

      }
    };


    fetchOnlineNow();

    const id = setInterval(fetchOnlineNow, 60_000);

    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return (
    <>
      {isAdminRoute && (
        <div
          dir="rtl"
          className="fixed top-4 left-4 z-[9999] flex items-center gap-2 rounded-full border px-4 py-2 text-xs md:text-sm backdrop-blur-sm shadow-lg"
          style={{
            borderColor: 'rgba(40,227,218,0.45)',
            background:
              'radial-gradient(120% 180% at 0% 0%, rgba(40,227,218,0.22) 0%, rgba(8,20,35,0.98) 50%, rgba(8,20,35,0.98) 100%)',
            color: '#E8FFF8'
          }}
        >
          <span
            className="inline-flex h-2 w-2 rounded-full animate-pulse"
            style={{ backgroundColor: '#19B228' }}
          />
          <span>متصل الآن:</span>
          <span style={{ fontWeight: 700 }}>
            {onlineNow.toLocaleString('en-US')}
          </span>
        </div>
      )}

      {                                                                             }
      <Routes>
        {                 }
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {                      }
        <Route
          path="/dashboard"
          element={
            <RequireAdmin>
              <DashboardPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/user-management"
          element={
            <RequireAdmin>
              <UserManagementPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/activity-log"
          element={
            <RequireAdmin>
              <ActivityLogPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/reports"
          element={
            <RequireAdmin>
              <ReportsPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/manage-courses-lecturers"
          element={
            <RequireAdmin>
              <ManageCourseLecturerPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/add-course-lecturer"
          element={
            <RequireAdmin>
              <AddCourseLecturerPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/maintenance-control"
          element={
            <RequireAdmin>
              <MaintenanceControlPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/popup-settings"
          element={
            <RequireAdmin>
              <PopupSettingsPage />
            </RequireAdmin>
          }
        />

        {                  }
        <Route
          path="/maintenance"
          element={
            <Layout>
              <MaintenancePage />
            </Layout>
          }
        />

        {                                }
        <Route
          path="/*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/evaluation" element={<ComingSoonPage />} />
                <Route
                  path="/course-evaluation"
                  element={
                  <RequireAdmin>
                    <CourseEvaluationPage />
                  </RequireAdmin>
                  }
                />
                <Route
                  path="/lecturer-evaluation"
                  element={<LecturerEvaluationPage />}
                />
                <Route path="/community" element={<ComingSoonPage />} />
                <Route
                  path="/services"
                  element={<ElectronicServicesPage />}
                />
                <Route path="/calculator" element={<CalculatorPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/profile" element={<ProfilePage />} />

                <Route path="/files" element={<FileStoragePage />} />
                <Route path="/ramadan" element={<RamadanSchedulePage />} />
                <Route path="/plan" element={<AcademicPlannerPage />} />
                <Route path="/explanations" element={<StudentExplanationsPage />} />


                {                                }
                <Route
                  path="/doctor-reviews/:slug"
                  element={<EvaluationDetailsPage />}
                />
                <Route
                  path="/course-reviews/:slug"
                  element={<EvaluationDetailsPage />}
                />

                {                         }
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const fallback = setTimeout(() => setShowLoader(false), 2500);
    return () => clearTimeout(fallback);
  }, []);

  return (
    <AuthProvider>
      <Router>
        {showLoader && (
          <LoadingScreen onFinished={() => setShowLoader(false)} />
        )}
        <MaintenanceGate>
          <AppContent />
        </MaintenanceGate>
      </Router>
    </AuthProvider>
  );
}

export default App;
